import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="vh-100 d-flex align-items-center justify-content-center bg-dark">
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3 text-light">Loading...</p>
                </div>
            </div>
        );
    }

    if (!user || !user.is_admin) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default AdminRoute;

